module.exports = __webpack_public_path__ + "static/assets/13f7f87eb40d2cdb24c20c5738c65677.png";